import Swiper, { Navigation, Pagination } from 'swiper';

class PartnersListItem {
  constructor(rootElement) {
    this.rootElement = rootElement;

    this.findElements();
    this.init();
  }

  findElements() {
    this.slider = this.rootElement.querySelector('[data-entity="slider"]');
    this.sliderNavPrev = this.rootElement.querySelector('[data-entity="nav-prev"]');
    this.sliderNavNext = this.rootElement.querySelector('[data-entity="nav-next"]');
    this.sliderPagination = this.rootElement.querySelector('[data-entity="pagination"]');
  }

  init() {
    this.swiper = new Swiper(this.slider, {
      modules: [Navigation, Pagination],

      slidesPerView: 2,
      spaceBetween: 8,

      pagination: {
        el: this.sliderPagination,
        type: 'bullets',
        dynamicBullets: true,
        dynamicMainBullets: 4,
      },

      breakpoints: {
        768: {
          slidesPerView: 'auto',
          spaceBetween: 56,

          pagination: false,

          navigation: {
            nextEl: this.sliderNavNext,
            prevEl: this.sliderNavPrev,
            disabledClass: 'nav__button_disabled',
          },
        },
      },
    });
  }
}

export default PartnersListItem;
